/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { formatMessageWithReferenceId, getRequestIdFromError } from "../../utils/requestCorrelation";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error boundary caught:", error, info);
    const requestId = getRequestIdFromError(error);

    if (this.props.showNotification) {
      this.props.showNotification(
        formatMessageWithReferenceId(
          error?.message || "Something went wrong",
          requestId,
        ),
        "error"
      );
    }

    if (this.props.onError) {
      this.props.onError(error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      // Using snackbar to show message instead of fallback UI
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
